import {combineReducers} from 'redux';

import {toasterReducers} from '@homeaway/react-toaster';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';

import content from './content';
import destination from './destination';
import greatPlaces from './greatPlaces';
import modules from './modules';
import search from './search';
import seoLinkpile from './seo-linkpile';
import propertyTypes from '../modules/PropertyTypes/redux';
import familyFriendly from '../modules/FamilyFriendly/redux';

function takeNoAction(state) {
    return state || {};
}

export const reducers = combineReducers({
    config: takeNoAction,
    abacus: takeNoAction,
    siteContext: takeNoAction,
    error: takeNoAction,
    content,
    destination,
    familyFriendly,
    greatPlaces,
    modules,
    propertyTypes,
    search,
    seoLinkpile,
    toaster: toasterReducers,
    tripboardButton: tripboardButtonReducer,
});

export default reducers;
